import "primeicons/primeicons.css"; //icons
import { PanelMenu } from 'primereact/panelmenu';
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { bool } from 'prop-types';
import { useHistory, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import "./Menu.css";
import { Card } from "primereact/card";
import useWindowDimensions from "../hooks/useDimensions";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Menu
Description : Menú que se depliega al interacturar con el botón burger
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas – Se implementa el menú desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

function Menu({ open, setOpen }) {
    /*Elementos y rutas del menú*/
    const location = useLocation();
    const history = useHistory();
    // const location = useLocation();
    const { width } = useWindowDimensions()

    // const [items, setItems] = useState(null);

    const closeMenu = () => {
        if (width <= 919) {
            setOpen(!open)
        }
    }

    const handleNavigation = (path, event) => {
        // Allow right-click default behavior
        if (event.type === "contextmenu") return;

        // Open in new tab if Ctrl+Click (Windows/Linux), Cmd+Click (Mac), or Middle Click
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            window.open(path, "_blank");
        } else {
            event.preventDefault(); // Prevent default navigation
            history.replace(path);
            closeMenu();
        }
    };

    const menuTemplate = (item, options) => {
        return (
            <a
                href={item.path}
                onClick={(event) => handleNavigation(item.path, event)}
                onContextMenu={(event) => handleNavigation(item.path, event)} // Allow right-click
                className={options.className}
                style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}
            >
                <span className={item.icon} style={{ marginRight: "8px" }}></span>
                <span>{item.label}</span>
            </a>
        );
    };

    let items = [
        {
            label: 'Inicio',
            icon: 'pi pi-fw pi-home',
            path: '/Home'
        },
        {
            label: 'Empleados',
            icon: 'pi pi-fw pi-user',
            path: '/Employes'
        },
        {
            label: 'Liquidación',
            icon: 'pi pi-fw pi-folder',
            path: '/Novelties'
        },
        {
            label: 'Programación',
            icon: 'pi pi-fw pi-clock',
            path: '/Scheduling'
        },
        {
            label: 'Consultas',
            icon: 'pi pi-fw pi-search',
            path: '/OpenPayroll'
        },
        {
            label: 'Configuración empresa',
            icon: 'pi pi-fw pi-sliders-h',
            path: '/CompanyInfo'
        },
        {
            label: 'Autogestión',
            icon: 'pi pi-fw pi-users',
            path: '/Certificate'
        },
        {
            label: 'Gestión usuarios',
            icon: 'pi pi-fw pi-sitemap',
            path: '/Users'
        },
        {
            label: 'Facturación y pagos',
            icon: 'pi pi-fw pi-credit-card',
            path: '/PayOrder'
        },
        {
            label: 'Soporte',
            icon: 'pi pi-fw pi-phone',
            path: '/Support'
        }
    ]

    let items2 = [
        {
            label: 'Certificado',
            icon: 'pi pi-fw pi-file-pdf',
            path: "/Certificate"
        },
        {
            label: 'Comprobante',
            icon: 'pi pi-fw pi-file-pdf',
            path: "/Voucher"
        },
        {
            label: 'Ingresos y retenciones',
            icon: 'pi pi-fw pi-file-pdf',
            path: "/CIRVoucher"
        },
        {
            label: 'Retención en la fuente',
            icon: 'pi pi-fw pi-briefcase',
            path: "/Retefuente"
        },
        {
            label: 'Gestión contraseña',
            icon: 'pi pi-fw pi-unlock',
            path: "/PasswordManagement"
        },

    ];

    let items3 = [
        {
            label: 'Inicio',
            icon: 'pi pi-fw pi-home',
            /* expanded: location.pathname.match(/Home/) ? true : false, */
            path: "/Home"
        },
        {
            label: 'Empleados',
            icon: 'pi pi-fw pi-user',
            path: "/Employes"
        },
        {
            label: 'Liquidación',
            icon: 'pi pi-fw pi-folder',
            path: "/Novelties"
        },
        {
            label: 'Consultas',
            icon: 'pi pi-fw pi-search',
            path: "/OpenPayroll"
        },
        {
            label: 'Configuración empresa',
            icon: 'pi pi-fw pi-sliders-h',
            path: "/CompanyInfo"
        },
        {
            label: 'Autogestión',
            icon: 'pi pi-fw pi-users',
            path: "/Certificate"
        },
        {
            label: 'Gestión usuarios',
            icon: 'pi pi-fw pi-sitemap',
            path: "/Users"
        },
        {
            label: 'Facturación y pagos',
            icon: 'pi pi-fw pi-credit-card',
            path: "/PayOrder"
        },
        {
            label: 'TI',
            icon: 'pi pi-fw pi-desktop',
            path: "/TI"
        },
        {
            label: 'Soporte',
            icon: 'pi pi-fw pi-phone',
            path: "/Support"
        }
    ]

    let styleOpen = {
        position: "fixed", top: 0, left: 0, marginTop: "3.6rem", marginBottom: "20rem",
        transform: "translate(0)", transition: "transform 0.3s ease-in-out",
        width: "20rem", zIndex: "-1 !important", height: 'calc(100vh - 54px)'
    };

    let styleClose = {
        position: "fixed", top: 0, left: 0, marginTop: "3.6rem", marginBottom: "20rem",
        transform: "translate(-100%)", transition: "transform 0.3s ease-in-out",
        width: "20rem", zIndex: "-1 !important", height: 'calc(100vh - 54px)'
    }

    /*Renderizado del componente*/
    /* if (localStorage.getItem('type') === "ADMIN" && localStorage.getItem('logo')) {
        return (
            <Card className={ open ? 'pm mobile-shadow' : 'pm'} style={ open ? styleOpen : styleClose } >
                <PanelMenu model={items} multiple={false}/>
            </Card>
        );
    } */
    if ((localStorage.getItem('enabled') === "N" && localStorage.getItem('type') === "ADMIN") || location.pathname.match(/Login/)) {
        return null
    }
    if (localStorage.getItem('type') === "ADMIN" && items) {
        if (localStorage.getItem('logo')) {
            styleOpen = { ...styleOpen, marginTop: "4.5rem" }
            styleClose = { ...styleClose, marginTop: "4.5rem" }
        }
        let newItems = localStorage.getItem('instance') === 'S' ? items3 : items
        return (
            <Card className={open ? 'pm mobile-shadow' : 'pm'} style={open ? styleOpen : styleClose} >
                <PanelMenu className="menu-lat" model={newItems.map(item => ({ ...item, template: menuTemplate }))} />
            </Card>
        );
    }
    if (localStorage.getItem('type') === "CLIENT") {
        return (
            <Card className={open ? 'pm mobile-shadow' : 'pm'} style={open ? styleOpen : styleClose} >
                <PanelMenu model={items2.map(item => ({ ...item, template: menuTemplate }))} />
            </Card>
        );
    }

    else {
        return null;
    }

}
Menu.propTypes = {
    open: bool.isRequired,
}
export default Menu;